// 后台业务管理接口封装（用户 / 私人定制 / 吉宅 / 价格 / 自动择日 / 订单 / 系统）。
// 仅依赖本模块 request.js。
import request from './request'

export const usersApi = {
  list: (keyword = '') => request.get('/yljx/admin/business/users', { params: { keyword } }),
  detail: (id) => request.get(`/yljx/admin/business/users/${id}`),
  setup: (id, payload) => request.post(`/yljx/admin/business/users/${id}/setup`, payload),
  disable: (id, vip) => request.post(`/yljx/admin/business/users/${id}/disable`, { vip }),
  // 转移到黑名单：ids 为单个 id 或 id 数组
  toBlacklist: (ids) => request.post('/yljx/admin/business/users/transfer-to-blacklist',
    Array.isArray(ids) ? { ids } : { id: ids })
}

export const userBlacklistApi = {
  list: (keyword = '') => request.get('/yljx/admin/business/user-blacklist', { params: { keyword } }),
  detail: (id) => request.get(`/yljx/admin/business/user-blacklist/${id}`),
  // 从黑名单还原回用户表：ids 为单个 id 或 id 数组
  restore: (ids) => request.post('/yljx/admin/business/user-blacklist/transfer-to-users',
    Array.isArray(ids) ? { ids } : { id: ids })
}

export const sirensApi = {
  list: (status = '') => request.get('/yljx/admin/business/sirens', { params: { status } }),
  detail: (id) => request.get(`/yljx/admin/business/sirens/${id}`),
  assign: (id, adminId) => request.post(`/yljx/admin/business/sirens/${id}/assign`, { admin_id: adminId }),
  complete: (id) => request.post(`/yljx/admin/business/sirens/${id}/complete`),
  return: (id, lable) => request.post(`/yljx/admin/business/sirens/${id}/return`, { lable })
}

export const jizhaisApi = {
  list: (status = '') => request.get('/yljx/admin/business/jizhais', { params: { status } }),
  detail: (id) => request.get(`/yljx/admin/business/jizhais/${id}`),
  assign: (id, adminId) => request.post(`/yljx/admin/business/jizhais/${id}/assign`, { admin_id: adminId }),
  complete: (id) => request.post(`/yljx/admin/business/jizhais/${id}/complete`)
}

export const pricesApi = {
  list: () => request.get('/yljx/admin/business/prices'),
  save: (items) => request.post('/yljx/admin/business/prices/save', items)
}

export const dateriqiApi = {
  list: (date = '') => request.get('/yljx/admin/business/dateriqi', { params: { date } }),
  saveYongshi: (payload) => request.post('/yljx/admin/business/yongshi/save', payload),
  deleteYongshi: (id) => request.post(`/yljx/admin/business/yongshi/delete/${id}`)
}

export const ordersApi = {
  list: (type = '', status = '') => request.get('/yljx/admin/business/orders', { params: { type, status } }),
  detail: (id) => request.get(`/yljx/admin/business/orders/${id}`),
  complete: (id) => request.post(`/yljx/admin/business/orders/${id}/complete`),
  refund: (id) => request.post(`/yljx/admin/business/orders/${id}/refund`)
}

// 权限开通订单（星盘页「开通功能」的明细账，对账用）
export const permissionOrdersApi = {
  list: (params = {}) => request.get('/yljx/admin/business/permission-orders', { params }),
  // 导出走 blob，保留 UTF-8 BOM，Excel 双击打开不乱码
  export: (params = {}) => request.get('/yljx/admin/business/permission-orders/export', { params, responseType: 'blob' }),
  // 手动补开：仅用于回调丢失的异常订单，后端幂等
  manualApply: (id, operator = '') => request.post(`/yljx/admin/business/permission-orders/${id}/manual-apply`, { operator })
}

export const systemApi = {
  overview: () => request.get('/yljx/admin/business/system/overview'),
  dashboard: () => request.get('/yljx/admin/business/dashboard'),
  // 日课基准经纬度：后台填写日课与客户侧时间反解共用（不再写死在代码里）
  baseLocation: () => request.get('/yljx/admin/business/system/base-location'),
  saveBaseLocation: (payload) => request.post('/yljx/admin/business/system/base-location', payload)
}
